import React from 'react';

export interface ListItemProps {
  text: string,
  activeValue: string,
  value: number | string,
  key: string,
  onClick: any
}

export const ListItem = ({ ...props }: ListItemProps) => {
  let className = "list-item";
  if (props.activeValue && props.activeValue.toString() === props.value.toString() && props.activeValue.toString() !== 'More') {
    className+=" active-list-item";
  }
  return (
    <li className={className} key={props.key} onClick={props.onClick} onKeyPress={props.onClick}>
        <p className="dropdown-text no-gutters" data-value={props.value} tabIndex={0}>{props.text}</p>
        <div className="dropdown-divider no-gutters" />
    </li>
  );
}